var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 10.218C19.2 9.53849 19.139 8.88509 19.0258 8.25781H10V11.9648H15.1576C14.9354 13.1627 14.2602 14.1777 13.2453 14.8572V17.2618H16.3424C18.1545 15.5934 19.2 13.1366 19.2 10.218Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99956 19.5828C12.5871 19.5828 14.7564 18.7247 16.342 17.261L13.2448 14.8565C12.3867 15.4315 11.289 15.7713 9.99956 15.7713C7.50354 15.7713 5.39085 14.0855 4.63725 11.8203H1.43555V14.3033C3.01244 17.4353 6.25335 19.5828 9.99956 19.5828Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63704 11.8238C4.44537 11.2488 4.33647 10.6346 4.33647 10.003C4.33647 9.37138 4.44537 8.75717 4.63704 8.18217V5.69922H1.43533C0.786281 6.99297 0.416016 8.4566 0.416016 10.003C0.416016 11.5494 0.786281 13.013 1.43533 14.3068L4.63704 11.8238Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99956 4.22952C11.4066 4.22952 12.6698 4.71304 13.663 5.66267L16.4117 2.91399C14.752 1.36759 12.5827 0.417969 9.99956 0.417969C6.25335 0.417969 3.01244 2.56551 1.43555 5.69751L4.63725 8.18047C5.39085 5.91532 7.50354 4.22952 9.99956 4.22952Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.c6eb1c54ceb754c1387c9c4f93c4ca76.svg";
export { ForwardRef as ReactComponent };